var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCanvasSelectedState = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 103,
    viewBox: "0 0 102 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3881_296)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 14.5337,
    width: 66,
    height: 66,
    rx: 15,
    stroke: "#5774FF",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16.5337,
    width: 62,
    height: 62,
    rx: 13,
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3881_296",
    x: 0,
    y: 0.533691,
    width: 102,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3881_296"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.454902 0 0 0 0 1 0 0 0 0.37 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3881_296"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3881_296",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCanvasSelectedState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/canvas_selected_state.1abb702d666d74da5574d5086db22884.svg";